import Helper from "./helper";
import components from "./components";
import popupFunc from "./popup";
// import directives from './directives'
// import Snackbar from './functions/snackbar'
export const MadUI = {
  install(Vue, options = { isIncludeCSS: true }) {
    if (process.env.VUE_DEVTOOLS_ENABLED) {
      Vue.config = {
        css: {
          loaderOptions: {
            sass: {
              data: `@import "./packages/mad-ui/src/scss/base";`,
            },
          },
        },
      };
    }

    if (options.isIncludeCSS) {
      require("./scss/base.scss");
    }
    // Vue.prototype.$snackbar = Snackbar(Vue)
    components(Vue);
    Vue.prototype.$popup = popupFunc(Vue);
    // directives(Vue)
  },
};

export default {
  MadUI,
  Helper,
};
